import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import AdvancedAlertsPage, { getDefaultPageUI } from "components/pages/AdvancedAlertsPage";
import ManageRecipientsContent from "components/pages/AdvancedAlertsPage/components/ManageRecipientsContent";

export default function CaptureNotifiLegacyManageRecipients(props) {
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    // Sets the component to be used for the content
    .update([ "content" ], ManageRecipientsContent)
    .submit();
    
    return <AdvancedAlertsPage ui={ ui } />
}